<template>
  <div class="main--content" id="PageRegister">
    <div class="container content-register">
      <Title :title="'Register'"></Title>

      <form @submit.prevent="processRegister">
        <div class="row">
          <div class="col wrapper-rounded-content">
            <div class="bg-blue-multiply rounded-corners"></div>

            <div v-if="step === 1" class="relative" data-vv-scope="step1">
              <div class="row" style="margin-top: 1.5rem">
                <div class="col col-md-12">
                  <h4>{{ $t("Zugangsdaten") }}</h4>
                </div>
              </div>

              <div class="row">
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    type="email"
                    autocomplete="email"
                    label=""
                    :validate="{ required: true }"
                    :placeholder="$t('Email address')"
                    :id="'email'"
                    :name="'email'"
                    v-model="form.email"
                  ></CsInput>
                </div>

                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInputToggle
                    scope="step1"
                    type="password"
                    autocomplete="password"
                    :validate="{ required: true }"
                    :placeholder="$t('password')"
                    :description="
                      $t('Dein Passwort muss mindestens 6 Zeichen lang sein.')
                    "
                    :id="'password'"
                    :name="'password'"
                    v-model="form.password"
                  ></CsInputToggle>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInputToggle
                    scope="step1"
                    type="password"
                    autocomplete="pin"
                    :validate="{ required: true, digits: 4 }"
                    :placeholder="$t('PIN Code')"
                    :description="$t('4-stelliger Zahlencode zum Öffnen des Fahrzeugs.')"
                    :id="'pin'"
                    :name="'pin'"
                    v-model="form.pin"
                  ></CsInputToggle>
                </div>
              </div>

              <div class="row" style="margin-top: 1.5rem">
                <div class="col col-md-12">
                  <h4>{{ $t("Personal data") }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <div class="btn-group">
                    <Dropdown
                      scope="step1"
                      v-model="form.salutation"
                      :validate="{ required: true }"
                      :buttonclass="'btn-light'"
                      :buttontext="'Salutation'"
                      :items="salutationsArray"
                    ></Dropdown>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    type="text"
                    autocomplete="firstname"
                    label=""
                    :validate="{ required: true }"
                    :placeholder="$t('First name')"
                    :id="'firstname'"
                    :name="'firstname'"
                    v-model="form.firstname"
                  ></CsInput>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    type="text"
                    autocomplete="lastname"
                    label=""
                    :validate="{ required: true }"
                    :placeholder="$t('Last name')"
                    :id="'lastname'"
                    :name="'lastname'"
                    v-model="form.lastname"
                  ></CsInput>
                </div>
              </div>
              <div class="row" style="margin-top: 1.5rem">
                <div class="col col-md-12">
                  <h4>{{ $t("Geburtsdatum") }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    type="date"
                    autocomplete="birthdate"
                    label="Geburtstag"
                    :required="true"
                    :validate="{ required: true, date_format: 'yyyy-MM-dd' }"
                    :placeholder="$t('Age')"
                    :id="'birthdate'"
                    :name="'birthdate'"
                    v-model="form.birthdate"
                  ></CsInput>
                </div>
              </div>
              <div class="row" style="margin-top: 1.5rem">
                <div class="col col-md-12">
                  <h4>{{ $t("Address") }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    :validate="{ required: true }"
                    autocomplete="billing address-city"
                    :placeholder="$t('City')"
                    :id="'city'"
                    :name="'city'"
                    v-model="form.city"
                  ></CsInput>
                </div>

                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    :validate="{ required: true }"
                    autocomplete="billing street-address"
                    :placeholder="$t('Street, number')"
                    :id="'street'"
                    :name="'street'"
                    v-model="form.street"
                  ></CsInput>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    :validate="{ required: true }"
                    autocomplete="billing postal-code"
                    :placeholder="$t('Zip code')"
                    :id="'zipCode'"
                    :name="'zipcode'"
                    v-model="form.zipcode"
                  ></CsInput>
                </div>

                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step1"
                    type="tel"
                    autocomplete="billing tel"
                    :required="true"
                    :validate="'required|numeric'"
                    :placeholder="$t('Telephone number')"
                    :id="'telephone'"
                    :name="'phone'"
                    v-model="form.phone"
                  ></CsInput>
                </div>
              </div>

              <div class="row" style="margin-top: 1.5rem">
                <div class="col-xs-12 col-sm-6 col-lg-3">
                  <button
                    class="btn btn-secondary btn-secondary--back btn-wp float-right"
                    @click.prevent="prev()"
                  >
                    {{ $t("Zurück") }}
                  </button>
                </div>
                <div class="col-xs-12 col-sm-6 offset-sm-6 col-lg-4 offset-lg-5">
                  <button
                    class="btn btn-primary btn-wp float-right"
                    @click.prevent="checkEmail"
                  >
                    {{ $t("Weiter") }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="step === 2" class="relative" data-vv-scope="step2">
              <div class="row" v-if="noPayment.value === '0'">
                <div class="col-xs-12">
                  <h3>Zahlungsmethode</h3>
                  <!-- <div style="margin-top: .5rem;" v-if="paymentCheck.mustPayment"><p class="mustpay">Gib mindestens einen Firmencode oder eine Zahlungsmethode an.</p></div> -->
                  <p class="mustpay" v-if="!isPayless">
                    Gib mindestens ein Payment oder einen Firmencode an.
                  </p>
                </div>
              </div>
			  <div class="row" v-else>
                <div class="col-xs-12">
                  <h3>Firmencode oder Gutschein</h3>
				  <p>Achtung: Bei Registrierung ohne Firmencode ist keine Reservierung möglich. <br> Der Firmencode oder die Bezahlmethode muss dann vor Ort verifiziert werden.</p>
                  <!-- <div style="margin-top: .5rem;" v-if="paymentCheck.mustPayment"><p class="mustpay">Gib mindestens einen Firmencode oder eine Zahlungsmethode an.</p></div> -->
                  <p class="mustpay" v-if="!isPayless">
                    Gib mindestens ein Payment oder einen Firmencode an.
                  </p>
                </div>
              </div>
              <div class="row" v-if="noPayment.value === '0' && hasConcardis.value === '1'">
                <div class="col col-xs-12" style="margin-top: 1.5rem">
                  <div
                    v-if="!form.payment_id"
                    id="inline-widget-container"
                    style="height: 400px"
                  ></div>
                  <div v-else>
                    <p>Bestätigte Methode: {{ form.payment_type }}</p>
                    <button
                      class="btn btn-outline-info btn-wp"
                      @click.prevent="changeConcardis"
                    >
                      Zahlungsmethode ändern
                    </button>
                  </div>
                </div>
              </div>
			  <div class="row" v-else>
                <div class="col col-xs-12" style="margin-top: 1.5rem">
                  <div>
                    <h4>Bitte verwenden Sie zur Einrichtung des Sepa-Lastschriftverfahrens die C-Share App.</h4>
                  </div>
                </div>
              </div>

              <div class="row" style="margin-top: 2.5rem">
                <div class="col col-md-12">
                  <h4>{{ $t("Firmenkunde") }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step2"
                    autocomplete="customer_code"
                    :placeholder="$t('Firmen-Code')"
                    :id="'customer_code'"
                    :name="'customer_code'"
                    v-model="form.customer_code"
                  ></CsInput>
                </div>
                <div class="col col-xs-12 col-sm-6 col-lg-4">
                  <p class="helptext">
                    Wenn erhalten, Firmen-Code eingeben
                  </p>
                </div>
              </div>
              <div class="row" style="margin-top: 1.5rem">
                <div class="col col-md-12">
                  <h4>{{ $t("Gutschein") }}</h4>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <CsInput
                    scope="step2"
                    autocomplete="voucher"
                    :placeholder="$t('Gutschein-Code')"
                    :id="'voucher'"
                    :name="'voucher'"
                    v-model="form.voucher"
                  ></CsInput>
                </div>
              </div>
              <div class="row" style="margin-top: 3rem">
                <div class="col-xs-12 col-sm-6 col-lg-3">
                  <button
                    class="btn btn-secondary btn-secondary--back btn-wp float-right"
                    @click.prevent="prev()"
                  >
                    {{ $t("Zurück") }}
                  </button>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-3 offset-lg-3">
                  <button
                    v-if="!form.payment_id"
                    class="btn btn-secondary btn-wp float-right"
                    @click.prevent="checkPayment('step2', false)"
                  >
                    Überspringen
                  </button>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-3">
                  <button
                    class="btn btn-primary btn-wp float-right"
                    @click.prevent="validate('step2')"
					v-if="noPayment.value === '0'  &&  hasConcardis.value === '1'"
                  >
                    <span class="btn-text">Weiter</span>
                  </button>
				  <button
                    class="btn btn-primary btn-wp float-right"
                    @click.prevent="checkPayment('step2', false)"
					v-else
                  >
                    <span class="btn-text">Weiter</span>
                  </button>
                </div>
              </div>
            </div>

            <div v-if="step == 3" class="relative" data-vv-scope="step3">
              <div class="row" style="margin-top: 1.5rem">
                <div class="col col-md-12">
                  <h2>{{ $t("Rechtliche Informationen") }}</h2>
                </div>
              </div>

              <div class="row" style="margin-top: 1.5rem">
                <div class="col-xs-12 col-sm-12 col-lg-12">
                  <CsInputCheck
                    scope="step3"
                    type="checkbox"
                    autocomplete="agbcheck"
                    :validate="{ required: true }"
                    :id="'agbcheck'"
                    :name="'agbcheck'"
                    :label="$t('Ich akzeptiere die Allgemeinen Geschäftsbedingungen*')"
                    :url="
                      $store.getters['orm/param']('SAPP_CONDITIONS_URL').value
                        ? $store.getters['orm/param']('SAPP_CONDITIONS_URL').value
                        : $store.getters['orm/param']('SAPP_IMPRINT_URL').value
                    "
                    v-model="form.agbcheck"
                  ></CsInputCheck>
                  <CsInputCheck
                    scope="step3"
                    type="checkbox"
                    autocomplete="dsgvocheck"
                    :validate="{ required: true }"
                    :id="'dsgvocheck'"
                    :name="'dsgvocheck'"
                    :label="$t('Ich stimme der Datenschutz-Grundverordnung zu*')"
                    :url="$store.getters['orm/param']('SAPP_PRIVACY_URL').value"
                    v-model="form.dsgvocheck"
                  ></CsInputCheck>
                </div>
              </div>

              <div class="row" style="margin-top: 1.5rem">
                <div class="col-xs-12 col-sm-6 col-lg-4 offset-lg-4">
                  <button
                    class="btn btn-secondary btn-secondary--back btn-wp float-right"
                    @click.prevent="prev()"
                  >
                    {{ $t("Zurück") }}
                  </button>
                </div>
                <div class="col-xs-12 col-sm-6 col-lg-4">
                  <button class="btn btn-primary btn-wp" @click.prevent="submit('step3')">
                    {{ $t("Registrierung abschließen") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
					<div class="col-12 text-center col-cta-button">
						<button type="submit" class="btn btn-primary btn-wp">
							{{ $t('Register for free') }}
						</button>
					</div>
				</div> -->
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PageRegister",
  computed: {
    ...mapGetters("orm", {groups:"groups", params:"params", salutations:"salutations"}),

    ...mapGetters("orm/reservation", {
      resStation: "station",
      resStartdate: "startdate",
      resEnddate: "enddate",
      resCar: "car",
      resNavigation: "navigation",
    }),
  },
  data() {
    return {
      step: 1,

      widgetRef: null,
      cofAgreementState: null,
      cofType: null,
      existsEmail: false,
      isCompanyVoucher: true,
      isVoucher: true,
      isPayless: true,
	  noPayment: {value: 0},
	  hasConcardis: false,
      merchant_id: "",
      optionalParameters: {
        language: "de",
        layout: "dropdown",
        customStyleId: "",
        hidePayButton: true,
        hideTitleIcons: true,
        skipFinalResultView: true,

        paymentDetails: {
          paypal: {
            returnUrl: "http://return.url",
            cancelUrl: "http://cancel.url",
          },
        },
        optionalFields: {
          creditCard: null,
          sepa: {
            bic: true,
            bankName: false,
            requestMandate: true,
            directDebitType: "FIRST",
          },
          paypal: null,
        },
      },

      paymentCheck: {
        error: false,
        mustPayment: true,
        payment: {
          required: false,
          success: false,
          error: false,
        },
        customer_code: {
          required: false,
          success: false,
          error: false,
        },
        voucher: {
          required: false,
          success: false,
          error: false,
        },
      },

      /* payment: {
				type: '',
				paymentData: {
					sepa: {
						accountHolder: null,
						iban: null,
						bic: null,
					},
					creditcard: {
						cardNumber: null,
						verification: null,
						expiryMonth: null,
						expiryYear: null,
					}
					
				},
				error: true
			}, */

      form: {
        // required
        email: "",
        password: "",
        pin: "",
        name: "",
        salutation: "",
        firstname: "",
        lastname: "",
        zipcode:"",
        city: "",
        street:  "",
        phone: "",
        birthdate: "",
        customer_code: "",
        voucher: "",
        payment_type: "",
        payment_id: "",
        payment_customer: "",
      },
	  salutationsArray: []
    };
  },
  beforeMount() {
    this.noPayment = this.$store.getters["orm/param"]("BCSAPP_NO_PAYMENT") || { value : 1};
    this.hasConcardis = this.$store.getters["orm/param"]("BCSAPP_USE_CONCARDIS");
	const initConc = () => {
		let payengine = document.createElement("script");
		payengine.setAttribute(
		"src",
		"https://pptest.payengine.de/bridge/1.0/payengine.min.js"
		);
		payengine.async = true;
		document.head.appendChild(payengine);

		let payengine_widget = document.createElement("script");
		payengine_widget.setAttribute(
		"src",
		"https://pptest.payengine.de/widgetjs/payengine.widget.min.js"
		);
		payengine_widget.async = true;
		document.head.appendChild(payengine_widget);
	}
	if (this.noPayment.value === "0" &&  this.hasConcardis.value === "1") {
		initConc();
	}

	if(!this.salutations){
		this.salutationsArray = 	[
							{ label: this.$t('Mr.'), value: 'Mr.' },
							{ label: this.$t('Ms.'), value: 'Ms.' },
						]
	}
	for (const key in this.salutations) {
		if (Object.hasOwnProperty.call(this.salutations, key)) {
			const element = this.salutations[key];
			this.salutationsArray.push({ label: element.salutation, value: element.id });

		}
	}
  },
  mounted() {
    if (!this.resStation) {
      this.$store.commit("orm/reservation/SET_NAVIGATION", false);
    }
    var self = this;
	if(self.noPayment.value === "0" && self.hasConcardis.value === "1") {
    self.optionalParameters.initCallback = this.initCallback;
    self.optionalParameters.cofAgreementStateCallback = this.cofAgreementStateCallback;
	}
  },
  methods: {
    resultCallback(error, paymentInstrument) {
      var threeDsVersionResult = null;
      var self = this;

      function onThreeDsAuthenticationResult(error, threeDsAuthenticationResult) {
        if (self.cofType === "ONECLICK") {
          if (cofAgreementState && cofAgreementState.checked) {
            // You need to create a cof contract with the upcoming order
          } else {
            // Store payment details is not checked
          }
        } else {
          if (self.cofType === "SCHEDULED" || self.cofType === "UNSCHEDULED") {
            window.PayEngine.cardCheck(
              paymentInstrument.paymentInstrumentId,
              self.cofType,
              null,
              function () {
                //Optionally you can call https://apitest.payengine.de/v1/payment-instruments/{paymentInstrument.paymentInstrumentId}
                //in order to get the final version of the payment instrument, including the newly created COF contract
              }
            );
          }
        }
      }

      function browserInfoCallback(error, result) {
        if (error) {
          //browserInfo call failed
          return;
        }
        var parameters = {
          browserInfoId: result.browserInfoId,
          type: "ADD_CARD",
          async: {
            notificationUrl: "http://notification.example",
            successUrl: "http://success.example",
            failureUrl: "http://failure.example",
          },
        };
        window.PayEngine.threeDsAuthenticationRequest(
          paymentInstrument.paymentInstrumentId,
          threeDsVersionResult.id,
          parameters,
          onThreeDsAuthenticationResult
        );
      }

      function invokeMethodUrlCallback() {
        window.PayEngine.getBrowserInfo(browserInfoCallback);
      }

      function onThreeDsVersionCallback(error, result) {
        threeDsVersionResult = result;
        if (result.version === "2.0") {
          if (result.specificData && result.specificData.methodUrl) {
            window.PayEngine.invokeMethodUrl(
              result.specificData.methodUrl,
              result.specificData.base64EncodedThreeDsMethodData,
              "inline-widget-container",
              invokeMethodUrlCallback
            );
          } else {
            invokeMethodUrlCallback();
          }
        } else {
          //3DS version is not 2
        }
      }

      if (error) {
        //Something went wrong with the creation of a payment instrument
      } else {
        window.PayEngine.threeDsVersion(
          paymentInstrument.paymentInstrumentId,
          onThreeDsVersionCallback
        );
      }

      console.log("Error/Result:", error, paymentInstrument);

      if (paymentInstrument.paymentInstrumentId) {
        this.form.payment_type = paymentInstrument.type;
        this.form.payment_id = paymentInstrument.paymentInstrumentId;
        this.paymentCheck["payment"].success = true;
        this.paymentCheck["payment"].error = false;
        this.paymentCheck.mustPayment = false;
        this.checkPayment("step2", true);
      }
    },

    validationListenerCallback(data) {
      console.log("Validation listener callback", data);
    },

    addValidationListener() {
      PayEngineWidget.addValidationListener(this.widgetRef, validationListenerCallback);
    },

    removeValidationListener() {
      PayEngineWidget.removeValidationListener(
        this.widgetRef,
        validationListenerCallback
      );
    },

    pay(step) {
      this.paymentCheck.payment.required = true;

      if (this.form.payment_id) {
        this.checkPayment("step2", true);
      } else {
        this.paymentCheck.mustPayment = true;
        this.paymentCheck["payment"].success = false;
        this.paymentCheck["payment"].error = true;

        PayEngineWidget.pay(this.widgetRef);
      }
    },

    validate(step) {
      var self = this;
      function onValidationCallback(error, result) {
        console.log("Validate", error, result);
        if (result == true) {
          self.pay();
        } else {
          self.checkPayment("step2", true);
        }
        //bridgeValidateResult(error ? error : result);
      }

      if (this.form.payment_id) {
        this.checkPayment("step2", true);
      } else {
        PayEngineWidget.validate(this.widgetRef, onValidationCallback);
      }
    },

    initCallback(error, iframeName) {
      console.log("Init callback", error, iframeName);
      this.widgetRef = iframeName;
    },

    cofAgreementStateCallback(error, result) {
      console.log("cofAgreementStateCallback", error, result);

      //You need to assign the coAgreementState for future usage
      this.cofAgreementState = result;
    },

    prev() {
      this.step--;
    },
    async next(scope) {
      var self = this;
      var error = false;
      this.$validator.validateAll(scope).then((valid) => {
        //console.log(self.existsEmail);
        if (self.existsEmail) {
          self.$validator.errors.add({
            id: "email",
            field: "email",
            msg: "E-Mail bereits vorhanden",
            scope: scope,
          });

          error = true;
        }

        if (self.GetAge(self.form.birthdate) < 18) {
          self.$validator.errors.add({
            id: "birthdate",
            field: "birthdate",
            msg: "Nicht 18",
            scope: scope,
          });

          error = true;
        }

        if (valid && !error) {
          this.step++;
          // do stuff if valid.
        } else {
          //this.$validator.errors.add({field: 'pin', msg: '', vmId: this.$validator.id });
        }
      });
    },
    submit(scope) {
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          this.processRegister();
          // do stuff if valid.
        } else {
          //this.$validator.errors.add({field: 'pin', msg: '', vmId: this.$validator.id });
        }
      });
    },
    changeConcardis() {
      this.form.payment_id = "";
      this.form.payment_type = "";
      this.paymentCheck.mustPayment = true;
      this.paymentCheck["payment"].success = false;
      this.paymentCheck["payment"].error = true;
      this.initConcardis();
    },
    initConcardis() {
      var self = this;
      setTimeout(() => {
        PayEngine.setPublishableKey(self.merchant_id);
        PayEngineWidget.initAsInlineComponentPi(
          "inline-widget-container",
          self.merchant_id,
          self.optionalParameters,
          self.resultCallback
        );
      }, 500);
    },
    async checkPayment(scope, paymentprocess) {
      var self = this;

      console.log(self.paymentCheck);

      if (self.form.customer_code != "") {
        self.paymentCheck.customer_code.required = true;
      } else {
        self.paymentCheck.customer_code.required = false;
        self.paymentCheck.customer_code.error = false;
      }
      if (self.form.voucher != "") {
        self.paymentCheck.voucher.required = true;
      } else {
        self.paymentCheck.voucher.required = false;
        self.paymentCheck.voucher.error = false;
      }
      if (paymentprocess == true) {
        self.paymentCheck.payment.required = true;
      } else {
        self.paymentCheck.payment.required = false;
        self.paymentCheck.payment.error = false;
      }
      if (self.form.customer_code == "" && self.form.payment_type == "") {
        if (self.isPayless) {
          self.paymentCheck.mustPayment = false;
        } else {
          self.paymentCheck.mustPayment = true;
        }
      }

      var didnothig = false;
      for (var type in self.paymentCheck) {
        if (self.paymentCheck[type].required && !self.paymentCheck[type].success) {
          didnothig = true;
          self.paymentCheck.error = true;
          if (type != "voucher") {
            self.paymentCheck.mustPayment = false;
          }

          self.processPayment(scope, type);
        }
      }

      if (didnothig == false) {
        self.doCheckPayment(scope);
      }
    },
    async doCheckPayment(scope) {
      var self = this;

      console.log(self.paymentCheck);

      if (
        !self.paymentCheck.payment.error &&
        !self.paymentCheck.customer_code.error &&
        !self.paymentCheck.voucher.error &&
        !self.paymentCheck.mustPayment
      ) {
        self.next("step3");
      }
    },
    async processPayment(scope, type) {
      var self = this;

      if (type == "customer_code") {
        self.isCompanyVoucher = false;
        this.$store
          .dispatch("orm/CHECK_VOUCHER", {
            code: self.form.customer_code,
            type: "COMPANYCODE",
          })
          .then((res) => {
            self.isCompanyVoucher = res.result;
            if (res.result == false) {
              self.$validator.errors.add({
                id: "customer_code",
                field: "customer_code",
                msg: "kein gültiger Code",
                scope: scope,
              });
              self.paymentCheck[type].error = true;
              self.doCheckPayment(scope);
            } else {
              self.paymentCheck[type].success = true;
              self.paymentCheck[type].error = false;
              console.log("comapany: " + self.paymentCheck.error);
              self.doCheckPayment(scope);
            }
          })
          .catch((err) => {
            this.$store.commit("core/ADD_ERROR", err);
          });
      }
      if (type == "voucher") {
        self.isVoucher = false;
        this.$store
          .dispatch("orm/CHECK_VOUCHER", {
            code: self.form.voucher,
            type: "REGISTRATION",
          })
          .then((res) => {
            self.isVoucher = res.result;
            if (res.result == false) {
              self.$validator.errors.add({
                id: "voucher",
                field: "voucher",
                msg: "kein gültiger Code",
                scope: scope,
              });
              self.paymentCheck[type].error = true;
            } else {
              self.paymentCheck[type].success = true;
              self.paymentCheck[type].error = false;

              console.log(self.paymentCheck.error);
            }
            self.doCheckPayment(scope);
          })
          .catch((err) => {
            this.$store.commit("core/ADD_ERROR", err);
          });
      }

      if (type == "payment") {
        //self.paymentCheck[type].error = true;
        //self.concardis(scope);
      }
    },
    /* concardis(scope){
			var self = this;


			var payload = {
				type : this.payment.type,
				payment: this.payment.paymentData[this.payment.type]
			}


			self.errors.clear();

			this.$validator.validateAll('step2').then(valid => {});
			
			this.$store.dispatch('orm/POST_PAYMENTINSTRUMENT', payload).then(res => { 

				self.form.payment_type = res.type;
				self.form.payment_id = res.paymentInstrumentId;
				self.paymentCheck['payment'].success = true;
				self.paymentCheck['payment'].error = false;
				self.doCheckPayment(scope);

			}).catch(err => {

				for (var field in err.response.data.errors) {
					self.$validator.errors.add({
						id: err.response.data.errors[field].field,
						field: err.response.data.errors[field].field,
						msg: err.response.data.errors[field].field,
						scope: scope,
					})
				}
				self.paymentCheck['payment'].error = true;
				
			});
			
			
		}, */
    processRegister(ev) {
      console.log(ev);
      var self = this;

      if (self.form.payment_id != "") {
        this.$store
          .dispatch("orm/CREATE_CONCARDIS_CUSTOMER", {
            email: self.form.email,
          })
          .then((res) => {
            self.form.payment_customer = res.customerId;

            console.log(res);
            console.log(self.form.payment_customer);
            self.$store
              .dispatch("orm/POST_CUSTOMER_PAYMENTINSTRUMENT", {
                payment_customer: self.form.payment_customer,
                payment_id: self.form.payment_id,
              })
              .then((res) => {
                self.$store
                  .dispatch("orm/CREATE_CUSTOMER", this.form)
                  .then((res) => {
                    if (res.success) {
                      this.$router.push({
                        name: "PagePostident",
                        params: { result: res },
                      });
                      return;
                      // nutzer wurde erstellt
                      // @todo redirect zu "login successfull page"
                    } else {
                      console.log("#11", res);
                    }
                  })
                  .catch((err) => {
                    this.$store.commit("core/ADD_ERROR", err);
                  });
              })
              .catch((err) => {
                this.$store.commit("core/ADD_ERROR", err);
              });
          })
          .catch((err) => {
            this.$store.commit("core/ADD_ERROR", err);
          });
      } else {
        self.$store
          .dispatch("orm/CREATE_CUSTOMER", this.form)
          .then((res) => {
            if (res.success) {
              this.$router.push({ name: "PagePostident", params: { result: res } });
              return;
              // nutzer wurde erstellt
              // @todo redirect zu "login successfull page"
            } else {
              console.log("#11", res);
            }
          })
          .catch((err) => {
            this.$store.commit("core/ADD_ERROR", err);
          });
      }
    },
    checkEmail(ev) {
      var self = this;
      this.$store
        .dispatch("orm/CHECK_CUSTOMER_EMAIL", {
          email: this.form.email,
        })
        .then((res) => {
          self.existsEmail = res.result.exists;
          self.next("step1");
        })
        .catch((err) => {
          this.$store.commit("core/ADD_ERROR", err);
        });
    },
    checkVoucher(type) {
      var self = this;
      if (this.form.customer_code && !this.form.voucher) {
        this.$store
          .dispatch("orm/CHECK_VOUCHER", {
            code: self.form.customer_code,
            type: type,
          })
          .then((res) => {
            self.isCompanyVoucher = res.result;
          })
          .catch((err) => {
            this.$store.commit("core/ADD_ERROR", err);
          });
      }
      if (this.form.voucher && !this.form.customer_code) {
        this.$store
          .dispatch("orm/CHECK_VOUCHER", {
            code: self.form.voucher,
            type: "REGISTRATION",
          })
          .then((res) => {
            self.isVoucher = res.result;
          })
          .catch((err) => {
            this.$store.commit("core/ADD_ERROR", err);
          });
      }

      if (this.form.voucher && this.form.customer_code) {
        this.$store
          .dispatch("orm/CHECK_VOUCHER", {
            code: self.form.customer_code,
            type: type,
          })
          .then((res) => {
            self.isCompanyVoucher = res.result;
            self.$store
              .dispatch("orm/CHECK_VOUCHER", {
                code: self.form.voucher,
                type: "REGISTRATION",
              })
              .then((res) => {
                self.isVoucher = res.result;
              })
              .catch((err) => {
                this.$store.commit("core/ADD_ERROR", err);
              });
          })
          .catch((err) => {
            this.$store.commit("core/ADD_ERROR", err);
          });
      }
    },
    GetAge(birthDate) {
      var today = new Date();
      var parseDate = Date.parse(birthDate);
      parseDate = new Date(parseDate);
      var age = today.getFullYear() - parseDate.getFullYear();
      var m = today.getMonth() - parseDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < parseDate.getDate())) {
        age--;
      }
      return age;
    },
  },

  watch: {
    step: function (newVal, oldVal) {
      console.log(this.paymentCheck);
      console.log(newVal);
      if (newVal === "2" && !this.form.payment_id && this.noPayment.value === "0") {
        // INIT CONCARDIS PAYENGINE
        this.initConcardis();
      }
    },
    "form.customer_code": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.paymentCheck["customer_code"].success = false;
      }
    },
    "form.voucher": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.paymentCheck["voucher"].success = false;
      }
    },
    "form.payment": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.paymentCheck["payment"].success = false;
      }
    },
    /* 'payment.paymentData.sepa.iban': function (newVal, oldVal){
			if (newVal !== oldVal){
				this.paymentCheck['payment'].success = false;
			}
		},
		'payment.paymentData.sepa.bic': function (newVal, oldVal){
			if (newVal !== oldVal){
				this.paymentCheck['payment'].success = false;
			}
		},
		'payment.paymentData.sepa.accountHolder': function (newVal, oldVal){
			if (newVal !== oldVal){
				this.paymentCheck['payment'].success = false;
			}
		},
		'payment.paymentData.creditcard.cardNumber': function (newVal, oldVal){
			if (newVal !== oldVal){
				this.paymentCheck['payment'].success = false;
			}
		},
		'payment.paymentData.creditcard.verification': function (newVal, oldVal){
			if (newVal !== oldVal){
				this.paymentCheck['payment'].success = false;
			}
		},
		'payment.paymentData.creditcard.expiryMonth': function (newVal, oldVal){
			if (newVal !== oldVal){
				this.paymentCheck['payment'].success = false;
			}
		},
		'payment.paymentData.creditcard.expiryYear': function (newVal, oldVal){
			if (newVal !== oldVal){
				this.paymentCheck['payment'].success = false;
			}
		}, */
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageRegister.vue